import { ReactElement, useEffect, useState } from "react";
import { api } from "../../../services/Api";

interface IAuthorize {
    code: ReactElement<any, any>;
    strict: boolean;
    userId?: number;
}

const Authorize: React.FC<IAuthorize> = (props) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [userId, setUserId] = useState(0);

    useEffect(() => {
        api.get("api/islogged")
            .then((response) => {
                if (response.status === 200) {
                    setIsLoggedIn(true);
                } else {
                    setIsLoggedIn(false);
                }
                return response.data;
            })
            .then((result) => {
                setUserId(result.userId);
            });
    }, []);

    useEffect(() => {
        if (props.strict) {
            if (isLoggedIn && userId === props.userId) {
                setIsAuthorized(true);
            }
        } else {
            setIsAuthorized(isLoggedIn);
        }
    }, [isLoggedIn, userId, props.userId]);

    return <div>{isAuthorized && props.code}</div>;
};

export default Authorize;
